// extracted by mini-css-extract-plugin
export var center = "_41-2";
export var clickableRow = "_41-5";
export var expandedRow = "_41-7";
export var hoverable = "_41-4";
export var left = "_41-1";
export var right = "_41-3";
export var row = "_41-0";
export var selectedRow = "_41-6";
export var summaryRow = "_41-8";